import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { RestService } from '../rest.service';
import { UserService } from '../user.service';

@Component({
  selector: 'app-zkregistros',
  templateUrl: './zkregistros.component.html',
  styleUrls: ['./zkregistros.component.scss']
})
export class ZkregistrosComponent implements OnInit {

  meses = [];
  month = 0;

  parking = [
    {
      'id' : '1',
      'nombre' : 'Jose María Buck'
    },
    {
      'id' : '2',
      'nombre' : 'Av. Novelda'
    },
    {
      'id' : '25',
      'nombre' : 'Canalejas'
    },
    {
      'id' : '26',
      'nombre' : 'Navas'
    },
    {
      'id' : '27',
      'nombre' : 'Gorrion'
    },
    {
      'id' : '0',
      'nombre' : 'OFICINA ELCHE'
    },
    {
      'id' : '62',
      'nombre' : 'PARKING ELCHE1'
    },
    {
      'id' : '63',
      'nombre' : 'PARKINGS DE ELCHE'
    }
  ];
  parking_id;

  yearsList: any[] = [];
  year = 0;

  employees: any[] = [];
  zk_user_device_id;

  days: any[] = [];
  day;

  data: any;
  newRegistryMode: boolean = false;
  newRegistry = '20XX-01-01 00:00:00';

  inout = 0;

  constructor(
    public user: UserService,
    private rest: RestService) { }

  ngOnInit() {}

  GetYears(){

    this.rest.getYears(this.zk_user_device_id).subscribe( (data) => {
      this.yearsList = data['data'];
    },
    error => {
      this.user.ErrorSwal(error);
    } );
  }

  GetMonth(){

    if ( this.year === undefined || this.year === null || !this.year ) {
      return Swal.fire({title: 'ERROR',text: 'Selecciona un año', icon: 'error', confirmButtonText: 'OK' }); 
    }


    this.rest.getMonth(this.zk_user_device_id,this.year).subscribe( (data) => {
      this.meses = data['data'];
    },
    error => {
      this.user.ErrorSwal(error);
    } );
  }

  AddRegistryMode(){ this.newRegistryMode = !this.newRegistryMode; }

  AddRegistry(){

    this.rest.newRegistry(this.newRegistry,this.inout,this.zk_user_device_id)
    .subscribe( (data) => {
      this.user.SuccessSwal('Datos guardados!',data['data']);
    },
    error => {
      this.user.ErrorSwal(error);
    } );
    
  }

  NewRegistryIsDisabled(){
    if ( this.parking_id === undefined || this.parking_id === null || !this.parking_id ) { return true; }
    if ( this.year === undefined || this.year === null || !this.year ) { return true; }
    if ( this.month === undefined || this.month === null || !this.month ) { return true; }
    if ( this.day === undefined || this.day === null || !this.day ) { return true; }
    if ( this.zk_user_device_id === undefined || this.zk_user_device_id === null || !this.zk_user_device_id ) { return true; }
    
    return false;
  }

  changeControl(index){
    this.data['data'][index].localEdited = 1;
  }

  EditRegistry(index){
    this.rest.editRegistry(this.data['data'][index])
    .subscribe( (data) => {
      this.user.SuccessSwal('Datos guardados!',data['data']);
    },
    error => {
      this.user.ErrorSwal(error);
    } );
    
  }

  GetDays(){

    
    if ( this.parking_id === undefined || this.parking_id === null || !this.parking_id ) {
      return Swal.fire({title: 'ERROR',text: 'Selecciona un parking', icon: 'error', confirmButtonText: 'OK' }); 
    }

    if ( this.month === undefined || this.month === null || !this.month ) {
      return Swal.fire({title: 'ERROR',text: 'Selecciona un mes', icon: 'error', confirmButtonText: 'OK' }); 
    }

    if ( this.year === undefined || this.year === null || !this.year ) {
      return Swal.fire({title: 'ERROR',text: 'Selecciona un año', icon: 'error', confirmButtonText: 'OK' }); 
    }

    this.rest.getDays(this.zk_user_device_id,this.month,this.year)
      .subscribe(
        (data) => this.days = data['data'],
        (error) => this.user.ErrorSwal(error));
  }

  GetEmployees(){
    Swal.fire({ title: 'Cargando', text: 'Espere por favor', icon: 'question' });
    Swal.showLoading();

    this.rest.getEmployees(this.parking_id).subscribe(
      (data) => {
        Swal.close();
        this.employees = data['data'];
    }, (error) => {
        Swal.close();     
      this.user.ErrorSwal(error);
    });
  }

  GetRegistry(){
    if ( this.parking_id === undefined || this.parking_id === null || !this.parking_id ) {
      return Swal.fire({title: 'ERROR',text: 'Selecciona un parking', icon: 'error', confirmButtonText: 'OK' }); 
    }
    if ( this.year === 0 ) { return Swal.fire({title: 'ERROR',text: 'Selecciona un año', icon: 'error', confirmButtonText: 'OK' }); }
    if ( this.month === 0 ) { return Swal.fire({title: 'ERROR',text: 'Selecciona un mes', icon: 'error', confirmButtonText: 'OK' }); }
    if ( this.day === 0 || this.day === undefined ) { return Swal.fire({title: 'ERROR',text: 'Selecciona un dia', icon: 'error', confirmButtonText: 'OK' }); }

    Swal.fire({ title: 'Cargando', text: 'Espere por favor', icon: 'question' });
    Swal.showLoading();

      this.rest.getRegistryEmployees(this.zk_user_device_id,this.year,this.month,this.day).subscribe(
        (data) => {
          Swal.close();
          this.data = data['data'];
      }, (error) => {
          Swal.close();
        this.data = [];      
       
      });
  }

  getIsDisabled(){
    if ( this.year === 0 ) { return true; }
    if ( this.month === 0 ) { return true; }
    if ( this.parking_id === undefined ) { return true; }


    return false;
  }

  deleteRegistry(index){

    Swal.fire({
      title: '¿ Desea borrar este registro ?',
      showCancelButton: true,
      confirmButtonText: `Borrar`,
      cancelButtonText: 'Cancelar',
    }).then((result) => {

      if (result.isConfirmed) {
        
        this.rest.DeleteRegistryZK(this.data['data'][index].id)
          .subscribe(
            (data) => Swal.fire(data['data'], '', 'success'),
            (er) =>  this.user.ErrorSwal(er));
      }
    })
  }

}
